import {
    Attribute,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    Renderer2,
    SimpleChanges
} from '@angular/core';

import { TransitionMode } from '../types/TransitionMode';
import { TransitionState } from '../types/TransitionState';

@Directive({
    selector: '[anjTransition]'
})
export class TransitionDirective implements OnChanges {

    private static supportedTransitions = ['opacity', 'transform'];

    @Input() public anjTransition: any;

    @Output() public end: EventEmitter<TransitionState>;

    private state: TransitionState = TransitionState.EnterTo;

    constructor(private renderer: Renderer2,
                private element: ElementRef,
                @Attribute('mode') public mode: TransitionMode,
                @Attribute('name') public name: string) {
        this.end = new EventEmitter<TransitionState>();

        this.mode = this.mode ? this.mode : 'in-out';
        this.name = this.name ? this.name : 'transition';
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.endTransition();

        if (!changes.anjTransition.previousValue && !changes.anjTransition.currentValue && this.mode !== 'out') {
            this.initEnter();
        } else if (!changes.anjTransition.previousValue && changes.anjTransition.currentValue) {
            this.transitionIn();
        } else {
            this.transitionOut();
        }
    }

    @HostListener('transitiend', ['$event'])
    public handleTransition(event: TransitionEvent): void {
        if (event.target === this.element.nativeElement && TransitionDirective.supportedTransitions.indexOf(event.propertyName) > -1) {
            event.stopPropagation();
            this.end.emit(this.state);

            if (this.state === TransitionState.Enter) {
                this.endTransition();
            } else {
                if (this.mode !== 'out' && this.anjTransition) {
                    this.transitionIn();
                } else {
                    this.endTransition();
                }
            }
        }
    }

    private initEnter(): void {
        this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-enter-to`);
    }

    private transitionIn(): void {
        if (this.mode !== 'out') {
            this.state = TransitionState.Enter;
            this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-enter-to`);
            this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-leave`);
            this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-leave-active`);
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-enter-active`);
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-enter`);
        } else {
            this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-enter-to`);
            this.endTransition();
        }
    }

    private transitionOut(): void {
        this.state = TransitionState.Leave;

        if (this.mode !== 'in') {
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-leave-active`);
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-leave`);
        } else {
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-enter-to`);
            this.state = TransitionState.EnterTo;

            if (this.anjTransition) {
                window.setTimeout(() => {
                    this.transitionIn();
                });
            }
        }
    }

    private endTransition(): void {
        this.state = TransitionState.Inactive;

        this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-enter-active`);
        this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-leave-active`);
        this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-enter`);
        this.renderer.removeClass(this.element.nativeElement, `anj-${this.name}-leave`);

        if (!this.anjTransition) {
            this.renderer.addClass(this.element.nativeElement, `anj-${this.name}-enter-to`);
        }
    }
}
